export default __webpack_public_path__ + "static/celtic_map-390f89f703cbcca6ac4808360adf7c43.svg";